<template>
	<div v-if="loadingSkillsets">
		<div class="loading">
			<Loader />
		</div>
	</div>
	<div v-else>
		<div class="container">
			<div class="skillset">
				<div class="">
					<h3 class="section__title">Select A Skill Set</h3>
					<ul class="skillset__grid">
						<li 
							v-for="skill in skillsets"
							:Key="skill.id" 
							class="panel__item">{{ skill.name }}
							<label class="check">
								<input 
									type="checkbox"
									:value="skill.id"
									v-model="selectedSkills">
								<span class="checkmark"></span>
							</label>
						</li>
					</ul>
					<div class="btn__group btn__group--flex">
						<button 
							class="btn__primary btn__main"
							@click="saveSkills">Save</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { getSkillsets, postSkillsets, getUserSkillsets } from '../utils/api/skillsets';
import Loader from '../components/Loader';
import { success, fail } from '../utils/toast';

export default {
	name: 'Skillset',
	data() {
		return {
			selectedSkills: [],
			skillsets: {},
			loadingSkillsets: true,
			skillsetsLoaded: false
		};
	},
	created() {
		this.getUserSkills();
	},
	methods: {
		getUserSkills() {
			getUserSkillsets(this.$session.get('id'))
				.then((response) => {
					if (response.status === 200) {
						if (!response.data.data.length) {
							this.getSkillsets();					
						} else {
							this.$router.push('/dashboard');
						}
					}
				})
				.catch((error) => {
					return error;
				});
			return true;
		},
		getSkillsets() {
			getSkillsets()
				.then((response) => {
					if (response.status === 200) {
						this.skillsetsLoaded = true;
						this.skillsets = response.data.data;
						return true;
					}
					return false;
				})
				.catch((error) => {
					this.skillsetsLoaded = false;
					return false;
				})
				.finally(() => {
					this.loadingSkillsets = false;
				});
			return true;
		},
		saveSkills() {
			postSkillsets(
				this.$session.get('id'),
				{
					skillsets_id: this.selectedSkills
				}
			)
				.then((response) => {
					if (response.status === 201) {
						success({
							title: 'Success! Skillsets have been succesfully created.'
						});
						this.$router.push('/dashboard');
						return true;
					}
					return false;
				})
				.catch((error) => {
					fail({
						title: 'Oops! Something went wrong',
						text: error.data
					});
					return error;
				});
		}
	},
	components: {
		Loader
	}
};
</script>

<style lang="scss" scoped>
.loading {
	display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
}
</style>
